<template>
  <div id='editCustomerRecord'>
    <pt-modal :title='$t(modalTitle)' :visible='visible' :width='800' @cancel='hide' :loading='loading'
              @ok='submit'>

      <div slot='content'>
        <div class='customer_record'>
          <a-form :form='form' layout='vertical' selfUpdate>
            <a-form-item v-show='false'>
              <a-input v-decorator="['id',{}]"></a-input>
            </a-form-item>
            <a-form-item v-show='false'>
              <a-input v-decorator="['dealId',{}]"></a-input>
            </a-form-item>
            <a-form-item v-show='false'>
              <a-input v-decorator="['pursuitsId',{}]"></a-input>
            </a-form-item>
            <a-row>
              <a-col :span='8'>
                <a-form-item class='required' :label=" trackStatus ? $t('customerRecord.trackTime') :  $t('customerRecord.time')">
                  <a-date-picker v-decorator='decorators.time' :disabled='defaultValue' style='width: 100%'
                                 format='YYYY-MM-DD'
                                 :disabledDate='disabledDate'>
                  </a-date-picker>
                </a-form-item>
              </a-col>
              <a-col :span='8'>
                <a-form-item class='required' :label="trackStatus ? $t('customerRecord.trackType') : $t('customerRecord.type')">
                  <ptSelect  @changeValue='changeType' :placeholder="trackStatus ? $t('customerRecord.trackTypeTip') : $t('customerRecord.typeTip')"
                            v-decorator='decorators.type'>
                    <a-select-option  v-for='o in customerRecordTypes' :key='o.wordKey' :value='o.wordKey'>
                      {{ o.wordValue }}
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if="dealId == null && projectId == null">
                <a-form-item   :label="trackStatus ? $t('customerRecord.companyRelation') : $t('customerRecord.relation')">
                  <ptSelect @changeValue='changeRelationType'  :placeholder="$t('customerRecord.relationTip')"
                            v-decorator='decorators.relationShip' :disabled="canEdit">
                    <a-select-option v-for='(nature,index) in relationTypes'
                                     :key='index' :value='nature.wordKey'>
                      {{ nature.wordValue }}
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>

              <a-col :span='8' v-if="trackStatus">
                <a-form-item  class='required' :label="trackStatus ? $t('customerRecord.demandStatus') : $t('customerRecord.relation')">
                  <ptSelect @changeValue='changetrackStatus'  :placeholder="trackStatus ? $t('customerRecord.demandStatusTip'):$t('customerRecord.relationTip')"
                            v-decorator='decorators.demandStatus' :disabled="canEdit">
                    <a-select-option  v-for="(item,index) in $t('track.demandStatustr') " :key="index" :value="item.value">{{item.name}}</a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>

              <a-col :span='8' v-if='dealId != null && !defaultValue'>
                <a-form-item class='required' :label="$t('customerRecord.projectStages')">
                  <pt-select :placeholder="$t('customerRecord.mansionIdTip')" v-decorator='decorators.projectStages'
                            :disabled='form.getFieldsValue().projectStages > 11'>
                    <a-select-option v-for='d in dealStages'  :key='d.wordKey' :value='d.wordKey'>{{ d.wordValue }}
                    </a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>

              <a-col :span='8' v-if='projectId != null && !defaultValue'>
                <a-form-item class='required' :label="$t('customerRecord.projectStages')">
                  <pt-select :placeholder="$t('keyqingxuanze')" v-decorator='decorators.projectStages'
                            :disabled='form.getFieldsValue().projectStages > 11'>
                    <a-select-option v-for='d in dealStages'  :key='d.value' :value='d.value'>{{ d.name }}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='dealId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <!--                  <a-slider id="test" :defaultValue="0"  v-decorator="decorators.projectPossible" @change="calculateBrokerage"/>-->
                  <pt-slider blackhills-yellow='true'
                             :edit-mode='true' :old-step='currProjectPossible' @changeStep='changePossible'
                             ref='possibleSliderRef'></pt-slider>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='dealId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')" class='required'>
                  <a-month-picker style='width:100%;' v-decorator='decorators.projectEndtime'
                                  :disabledDate='disabledMonthDate'></a-month-picker>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='dealId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                  <a-input-group compact>
                    <pt-input-number :precision='2' style='width:70%;' v-decorator='decorators.totalBrokerage' :min='0'
                                     :max='99999999'
                                     :placeholder="$t('deal.addDeal.brokerage.totalBrokerageTips')"></pt-input-number>
                    <pt-unit-select style='width: 30%;' type='currency' v-decorator='decorators.totalBrokerageUnit'
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='projectId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <!--                  <a-slider id="test" :defaultValue="0"  v-decorator="decorators.projectPossible" @change="calculateBrokerage"/>-->
                  <pt-slider blackhills-yellow='true'
                             :edit-mode='true' :old-step='currProjectPossible' @changeStep='changePossible'
                             ref='possibleSliderRef'></pt-slider>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='projectId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')" class='required'>
                  <a-month-picker style='width:100%;' v-decorator='decorators.projectEndtime'
                                  :disabledDate='disabledMonthDate'></a-month-picker>
                </a-form-item>
              </a-col>
              <a-col :span='8' v-if='projectId != null && !defaultValue'>
                <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                  <a-input-group compact>
                    <pt-input-number :precision='2' style='width:70%;' v-decorator='decorators.totalBrokerage' :min='0'
                                     :max='99999999'
                                     :placeholder="$t('deal.addDeal.brokerage.totalBrokerageTips')"></pt-input-number>
                    <pt-unit-select style='width: 30%;' type='currency' v-decorator='decorators.totalBrokerageUnit'
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col v-if='!dealId && !pursuitsId && !projectId'>
                <a-form-item >
                  <span slot='label' style='position: relative'>
                    {{ $t('customerRecord.peerUsers') }}
<!--                    <a-checkbox v-model='peer' @change='PeerChange'-->
<!--                                style='float: right;padding-top: 3px'>{{ $t('customerRecord.peer') }}</a-checkbox>-->
                  </span>
<!--                  <pt-user-select mode='multiple' v-if='peer' :disabled='true'-->
<!--                                  :placeholder="$t('customerRecord.peerUsersTip')"-->
<!--                                  :disabled-users='[userInfo.accountDO.id]' :maxTagCount='1' v-decorator="['peerUsers', {-->
<!--                    rules:   [-->

<!--                    ], initialValue: undefined-->
<!--                  }]"></pt-user-select>-->
                  <pt-user-select mode='multiple'  :placeholder="$t('customerRecord.peerUsersTip')"
                                  :disabled-users='[userInfo.accountDO.id]' :maxTagCount='1' v-decorator="['peerUsers', {
                    rules:   [], initialValue: undefined
                  }]"></pt-user-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row>
              <!-- 跟进类型为看楼才显示-->
              <a-col :span='24' v-if='type == 3 && projectId == null'>
                <a-form-item class='required' :label="$t('customerRecord.mansionId')">
                  <div @click='openSelectMansion'>
                    <pt-select v-decorator='decorators.mansionId'
                               :placeholder="$t('customerRecord.mansionIdTip')"
                               :defaultActiveFirstOption='false'
                               :showArrow='false'
                               :filterOption='false'
                               :maxTagCount='3' :maxTagTextLength='13'
                               :notFoundContent='null'
                               mode='multiple'
                               @change='mansionChange'
                    >
                      <a-select-option v-for='m in mansionOptions' :key='m.id' :value='m.id'>{{ m.name }}
                      </a-select-option>
                    </pt-select>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span='24'>
                <a-form-item class='required' :label="$t('customerRecord.content')">
                  <a-textarea :placeholder="$t('customerRecord.contentTip')" v-decorator='decorators.content'
                              :autosize='{minRows:3,maxRows:3}' style='background-color:#ffffff;'>
                  </a-textarea>
                </a-form-item>
              </a-col>

              <div v-if='pictureIds.length > 0  && ( dealId || projectId)'>
                <a-col :span='4' style='display: flex;justify-content: center;align-items: center'
                       v-for='(item,index) in pictureIds' :key="item.id || item.pictureId || item || index">
                  <div>
                    <a-form-model-item prop='pictureIds' :colon='false' v-decorator='pictureIds'>
                      <div class='operationDivs'>
                        <div style='position: relative;border-radius: 2px'>
                          <div v-if='item!=undefined'>
                            <pt-image :src='$util.getFileUrl(item.pictureId)' :key='index' fit='cover' :z-index='3000'
                                      :preview-src-list='getImages(item.pictureId)'
                                      style='width: 103px;height: 64px;border-radius: 2px'></pt-image>
                            <div @click.stop='deleteImage(index)'
                                 style='position: absolute;bottom: 5px;height: 22px;width:100%;opacity: 0.56;background: #1A1A1A;border-radius: 0px 0px 4px 4px;
                                   display: flex;justify-content: center'>
                              <pt-icon style='color: #FFFFFF;font-size: 17px' type='icon-tubiao'></pt-icon>
                            </div>

                          </div>
                          <div v-else
                               style='width: 103px;height: 64px;display: flex;justify-content: center;align-items: center;background: #E6E6E6;border-radius: 2px;'>
                            <div style='display: flex;align-items: center;flex-direction: column'>
                              <pt-icon type='icon-zengjia' style='font-size: 20px;color: #666666'></pt-icon>
                              <div style='display: flex;align-items: center;margin-top: 8px'>
                          <span
                            style='font-size: 12px;color: #B7B7B7;font-weight: 600;'>{{ $t('pictureInfo.tableHeader.addPicture')
                            }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <oss-upload v-if='pictureIds.length < 0 ' :multiple='true' :is-cropper='false'
                                  fileSuffix='png,jpg,jpeg'
                                  @onSuccess='uploadImgSuccess'>
                      </oss-upload>
                      <div style='display: flex;flex-direction: column'>
                        <a-checkbox v-model='item.synchro'>
                          {{ $t('customerRecord.synchroPicture') }}
                        </a-checkbox>
                      </div>
                    </a-form-model-item>
                  </div>
                </a-col>
              </div>

              <div v-if='pictureIds.length < 6 && ( dealId || projectId)'>
                <a-col :span='4'>
                  <div>
                    <a-form-model-item prop='pictureIds' :colon='false' v-decorator='pictureIds'>
                      <oss-upload :limit='6' :multiple='true' :is-cropper='false' fileSuffix='png,jpg,jpeg'
                                  @onSuccess='uploadImgSuccess' :isMultipartUpload='false' :number='1'>
                        <div class='operationDivs'>
                          <div style='position: relative;border-radius: 2px'>
                            <div
                              style='width: 103px;height: 64px;display: flex;justify-content: center;align-items: center;background: #E6E6E6;border-radius: 2px;'>
                              <div style='display: flex;align-items: center;flex-direction: column'>
                                <pt-icon type='icon-zengjia' style='font-size: 20px;color: #666666'></pt-icon>
                                <div style='display: flex;align-items: center;margin-top: 8px'>
                          <span
                            style='font-size: 12px;color: #B7B7B7;font-weight: 600;'>{{ $t('pictureInfo.tableHeader.addPicture')
                            }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </oss-upload>

                    </a-form-model-item>
                  </div>
                </a-col>
              </div>


            </a-row>
          </a-form>
        </div>
      </div>
      <div slot='footer'>
        <div style='display: flex'>
          <div v-if='isCustomer'>
            <a-checkbox class='isSecrecy' v-model='isSecrecy'>{{ $t('keybaomigouxuanhouzhiyoubenrenkandedao') }}</a-checkbox>
          </div>
          <div style='flex: auto'>
            <a-button  @click='hide'>{{ $t('key10quxiao') }}</a-button>
            <a-button type="primary" :loading="loading"  @click='submit'>{{ $t('keyqueding') }}</a-button>
          </div>
        </div>
      </div>
    </pt-modal>
    <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible='selectModel.visable'
              :loading='selectModel.loading'
              @ok='submitEvent' @cancel='cancelEvent' :width='800'>
      <div slot='content'>
        <select-mansion :radio='false' :mansionList='mansionList' ref='selectMansion'
                        @confirmSelect='confirmSelect'></select-mansion>
      </div>
    </pt-modal>

  </div>
</template>

<script>
import { getDatadictChildsByPath } from '@/api/sys/datadict'
import customerRecordsApi from '@/api/customerRecords/customerRecords'
import recordsApi from '@/api/mine/customerRecords'
import mansionApi from '@/api/database/mansion'
import selectMansion from '../../database/proprietor/module/selectMansion'
import OssUpload from '../../../components/upload/ossUpload'
import Api from '@/api/mine/customerRelation'
import projectApi from '@/api/mine/projects/projects'

import { mapState } from 'vuex'

export default {
  name: 'editCustomerRecord',
  components: {
    selectMansion, OssUpload
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    trackStatus:{
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Object,
      default: () => {
        return null
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    dealId: {
      type: String,
      default: null
    },
    projectId: {
      type: String,
      default: null
    },
    modalTitle: {
      type: String,
      default: 'deal.button.follow'
    },
    pursuitsId: {
      type: String,
      default: null
    },
    customerId: {
      type: String,
      default: null
    },
    dealOriginType: {
      type: String,
      default: 1
    },
    typeChangeVisible: {
      type: Boolean,
      default: false
    },
	  mansionId:{
		  type: String,
		  default: null
	  },
    isCustomer:false,
    customerCompanyId:undefined,
  },
  data() {
    let vm = this
    return {
      typeShow: vm.$t('pictureInfo.typeShow'),
      synchroVisible: [],
      tips: [],
      checked: [],
      synchro: [],
      oldDemandStatustr:null,
      DemandStatusType:false,
      inductionBasicImage: [],
      pictureIds: [],
      mansionList: [],//选中楼宇的值
      selectModel: {
        visable: false,
        loading: false
      },
      isSecrecy: false,
      peer: false,
      currProjectPossible: 0,
      canEdit:false,
      //loading:false,//防止重复提交
      type: null,//跟进类型
      relationType: null,
      demandStatus:null,
      mansionOptions: [],
      form: this.$form.createForm(this, {}),
      customerRecordTypes: [],
      dealStages: [],
      relationTypes: [],
      oldRecord: null,
      oldDemandStatus:null,
      oldRelation: null,
      oldType:null,
      decorators: {
        pictureIds: ['pictureIds', {
          rules: [{
            required: true,
            message: this.$t('mansion.options.files'),
            trigger: 'blur'
          }]
        }],
        projectStages: ['projectStages', {
          rules: [{
            required: true,
            message: this.$t('customerRecord.projectStagesTip')
          }], initialValue: undefined
        }],
        peerUsers: ['peerUsers', {
          rules: [
            { message: this.$t('customerRecord.timeTip') }
          ], initialValue: undefined
        }],
        time: ['time', {
          rules: [{ required: true, message: this.trackStatus ? this.$t('customerRecord.timeTrack') : this.$t('customerRecord.timeTip') }],
          initialValue: this.$moment()
        }],
        type: ['type', {
          rules: [{ required: true, message: this.trackStatus ?  this.$t('customerRecord.trackTypeTip') :  this.$t('customerRecord.typeTip') }],
          initialValue: undefined
        }],
        mansionId: ['mansionId', {
          rules: [{ required: true, message: this.$t('customerRecord.mansionIdTip') }],
          initialValue: undefined
        }],
        content: ['content', {
          rules: [{ required: true, message: this.$t('customerRecord.contentTip') }, {
            max: 512,
            message: this.$t('customerRecord.contentLenTip')
          }], initialValue: undefined
        }],
        totalBrokerage: [
          'totalBrokerage', { rules: [] }
        ],
        totalBrokerageUnit: [
          'totalBrokerageUnit', {}
        ],
        projectPossible: [
          'projectPossible', {}
        ],
        projectEndtime: [
          'projectEndtime', {
            rules: [{ required: true, message: this.$t('deal.addDeal.errorInfo.projectEndtime') }]
          }
        ],
        relationShip: ['relationShip', {
          rules: [{  message:this.$t('customerRecord.relationTip') }],initialValue :undefined
        }],
        demandStatus: ['demandStatus', {
          rules: [{ required: true, message: this.$t('customerRecord.demandStatusTip') }],initialValue :undefined
        }],
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  mounted() {


  },
  methods: {
    init(){
      this.initDealStages(this.dealOriginType)
      this.initCustomerRecordTypes()
      this.initMansionOptions()
      this.initTypes()
      this.initChecked()
      this.getRelationsSelects()
    },
    PeerChange(value) {
      // if(!value){
      this.form.clearField('peerUsers')
      this.form.setFieldsValue({ 'peerUsers': undefined })
      // }
    },
    getRelationsSelects() {
      getDatadictChildsByPath('system.business_key.relation').then(res => {
        this.relationTypes = res.data
      })
    },
    selectCustomerRecords() {
      let this_ = this
      recordsApi.selectRelationByBusinessId(this_.customerId).then(res => {
        this_.oldRecord = res.data
        // console.log("this_.oldRecord",res.data)
        // if (this_.oldRecord.newDemandStatus != '~') {
        //   //如果上一条有新关系则将以前的关系变更为历史关系
        //   this_.oldDemandStatus = this_.oldRecord.newDemandStatus
        //   this_.decorators.demandStatus[1].initialValue= this_.oldRecord.newDemandStatus
        // }else if(this_.oldRecord.newDemandStatus == '~'){
        //   this_.oldDemandStatus = this_.oldRecord.oldDemandStatus
        //   if (this_.oldRecord.oldDemandStatus!='~'){
        //     this_.decorators.demandStatus[1].initialValue= this_.oldRecord.oldDemandStatus
        //   }
        // }
        // console.log("canEdit",this.canEdit)
        // console.log(" this_.oldRecord.isSecrecy", this_.oldRecord.isSecrecy)
        // if (this.canEdit){
        //   this_.isSecrecy = this_.oldRecord.isSecrecy
        // }

        console.log("this_.oldRecord",res.data)

        if (this_.oldRecord.newRelation != '~' ) {
          //如果上一条有新关系则将以前的关系变更为历史关系
          this_.oldRelation = this_.oldRecord.newRelation
          this_.decorators.relationShip[1].initialValue= this_.oldRecord.newRelation
        }else if(this_.oldRecord.newRelation == '~'){
          this_.oldRelation = this_.oldRecord.oldRelation
          if (this_.oldRecord.oldRelation!='~'){
            this_.decorators.relationShip[1].initialValue= this_.oldRecord.oldRelation
          }
        }

        // if (this_.oldRecord.type != '~' && this_.oldRecord.type != '0' ) {
        //   //如果上一条有新关系则将以前的关系变更为历史关系
        //   this_.oldType = this_.oldRecord.type
        //   this_.decorators.type[1].initialValue= this_.oldRecord.type
        // }else if(this_.oldRecord.type == '~'){
        //   this_.oldType = this_.oldRecord.oldType
        //   if (this_.oldRecord.oldType!='~'){
        //     this_.decorators.type[1].initialValue= this_.oldRecord.oldType
        //   }
        // }

      })

    },

    initTypes() {
      for (let i = 0; i < 6; i++) {
        this.tips.push(0)
      }
    },

    initChecked() {
      for (let i = 0; i < 6; i++) {
        this.checked.push(false)
      }
    },

    //选择标签
    choiceType(ind, value) {
      if (this.pictureIds[ind].tip == value) {
        this.pictureIds[ind].tip = ''
        this.pictureIds[ind].synchro = false
      } else {
        this.pictureIds[ind].tip = value
        this.pictureIds[ind].synchro = true
      }
      this.synchroVisible[ind] = false
      console.log('this.tips', this.tips)
    },

    //确定标签
    getTips(index) {
      this.pictureIds[index].synchro = this.pictureIds[index].tip != ''
      this.synchroVisible.splice(index, 1, false)
      console.log('this.checked', this.checked)
    },

    //同步
    synchroChange(ind) {
      // if(this.checked[ind]){
      // this.checked.splice(ind,1,false)
      // this.synchroVisible.splice(ind,1,false)
      // this.tips.splice(ind,1,0)
      // }
      //
      this.synchroVisible[ind] = true
      console.log('ind', ind)
      console.log('ind', this.synchroVisible[ind])
    },

    getImages(fileId) {
      let url = this.$util.getFileUrl(fileId)
      let list = []
      list.push(url)
      return list
    },


    //显示图片
    getImageUrl(fileId) {
      console.log('fileIdfileIdfileId', fileId)
      let url = this.$util.getFileUrl(fileId)
      return url
    },

    //删除图片
    deleteImage(index) {
      console.log('deleteImage', index)

      this.pictureIds.splice(index, 1)

      // this.pictureIds.
      // this.form.pictureDepot.outImage = undefined
    },

    //上传图片
    uploadImgSuccess(file, fileId, number) {
      let images = this.inductionBasicImage.find(o => o.type == number)
      if (images) {
        images.fileId = fileId
        images.fileName = file.name
      } else {
        this.inductionBasicImage.push({
          type: number,
          fileId: fileId,
          fileName: file.name
        })
      }
      if (this.pictureIds.length == 6) {
        return
      }
      console.log('number', fileId)
      this.pictureIds.push({ pictureId: fileId, synchro: false, tip: '' })
      console.log('number', this.pictureIds)
    },


    disabledDate(current) {
      // Can not select days before today and today
      return current && current > this.$moment().endOf('day')
    },
    disabledMonthDate(current) {
      //禁用当前月之前的日期
      return current && current <= this.$moment().month(this.$moment().month() - 1).endOf('month')
    },
    submitEvent() {
      this.$refs.selectMansion.confirmSelect()
    },
    openSelectMansion() {
      this.selectModel.visable = true
    },
    cancelEvent() {
      this.selectModel.visable = false
    },
    confirmSelect(mansionList) {
      this.mansionList = mansionList
      this.mansionOptions = []
      let mansionIds = []
      this.mansionList.forEach(item => {
        this.mansionOptions.push({ id: item.id, name: item.name })
        mansionIds.push(item.id)
      })
      this.$nextTick(() => {
        this.form.setFieldsValue({ mansionId: mansionIds })
      })
      this.cancelEvent()
    },
    mansionChange(value) {
      console.log('mansionList', this.mansionList)
      console.log('value', value)
      for (var i = 0; i < this.mansionList.length; i++) {
        let indexOf = value.indexOf(this.mansionList[i].id)
        if (indexOf == -1) {
          this.mansionList.splice(i, 1)
          i--
        }
      }
      this.fillMansionOptions()
    },
    fillMansionOptions() {
      this.mansionOptions = []
      this.mansionList.forEach(data => {
        let mansionOption = {
          name: data.name,
          id: data.id
        }
        this.mansionOptions.push(mansionOption)
      })
    },
    calculateBrokerage() {

    },
    changePossible() {
      this.currProjectPossible = this.$refs.possibleSliderRef.currStep
    },
    changeType(value) {
      console.log('类型改变', value)
      this.type = value
    },
    changeRelationType(value) {
      console.log('关系改变', value)
      this.relationType = value
    },
    changetrackStatus(value){
      console.log('需求状态改变', value)
      this.demandStatus = value
    },
    hide() {
      this.$emit('hide')
      this.canEdit=false
    },
    initProjectStages(){
      projectApi.selectProjectStages().then(res=>{
        if(res.code == 1){
          this.dealStages = res.data.filter(o=>o.value < 12);
        }
      })
    },
    initDealStages(dealOriginType) {
      if(this.projectId != null){
        this.initProjectStages();
      }else{
        if (dealOriginType == 1) {
          // let projectStages = this.$t('deal.dealDetails.leaseProjectStageTypes')
          getDatadictChildsByPath('system.business_key.leaseProjectStages').then(res => {
            this.dealStages = res.data.filter(p => {
              return p.wordKey != 12 && p.wordKey !=13 && p.wordKey != 4
            })
            // this.dealStages.forEach(e=>{
            //   e.wordValue = projectStages[e.wordKey]
            // })
          })
        } else {
          // let projectStages = this.$t('deal.dealDetails.consultantProjectStageTypes')
          getDatadictChildsByPath('system.business_key.consultantProjectStages').then(res => {
            this.dealStages = res.data.filter(p => {
              return p.wordKey < 6
            })
            // this.dealStages.forEach(e=>{
            //   e.wordValue = projectStages[e.wordKey]
            // })
          })
        }
      }
    },
    initDealStagesWithValue(value) {
      let projectStages = this.$t('deal.dealDetails.leaseProjectStageTypes')
      this.dealStages = [{ wordKey: value, wordValue: projectStages[value] }]
    },
    setDefaultValue(dealDO) {
      let value = dealDO.projectStages
      this.initDealStages(dealDO.dealOriginType)
      if (dealDO.dealOriginType == 1) {
        //可以结佣及之后的阶段
        if (value >= 11 && value < 14) {
          this.initDealStagesWithValue(value)
        }
      } else {

      }
      this.pictureIds = []
      this.$nextTick(() => {
        this.currProjectPossible = dealDO.projectPossible
        this.form.setFieldsValue(
          {
            projectStages: dealDO.projectStages == 13 ? '1' : dealDO.projectStages + '',
            totalBrokerage: dealDO.totalBrokerage,
            totalBrokerageUnit: dealDO.totalBrokerageUnit,
            content: dealDO.content,
            // projectPossible: dealDO.projectPossible,
            projectEndtime: dealDO.projectEndtime != '~' ? this.$moment(dealDO.projectEndtime) : undefined
            // time: this.$moment()
          }
        )
      })
    },
    setProjectDefaultValue(projectDO) {
      let value = projectDO.stage;
      this.initProjectStages()

      this.pictureIds = []
      this.$nextTick(() => {
        this.currProjectPossible = projectDO.projectPossible
        this.form.setFieldsValue(
          {
            projectStages: value,
            totalBrokerage: projectDO.totalBrokerage,
            totalBrokerageUnit: projectDO.totalBrokerageUnit,
            content: projectDO.content,
            projectPossible: projectDO.projectPossible,
            mansionId:[projectDO.mansion],
            projectEndtime: projectDO.projectEndTime != '~' ? this.$moment(projectDO.projectEndTime) : undefined
            // time: this.$moment()
          }
        )
      })
    },
    initDefaultValue() {
      if (this.defaultValue) {
        this.canEdit=true
        let defaultValue = JSON.parse(JSON.stringify(this.defaultValue))
        console.log('defaultValue', defaultValue)
        if (defaultValue.pictureSyc && defaultValue.pictureSyc != '~') {
          let pictureSycs = JSON.parse(JSON.stringify(defaultValue.pictureSyc))
          if (pictureSycs.length > 0) {
            this.pictureIds = []
            pictureSycs.forEach((item, index) => {
              this.pictureIds.push(item)
            })
          }
        }

        defaultValue.time = this.$moment(defaultValue.time)
        this.peer = defaultValue.peer == 1 ? true : false
        defaultValue.projectEndtime = this.$moment(defaultValue.projectEndtime)
        defaultValue.projectStages = defaultValue.projectStages + ''
        if (defaultValue.customerRecordsMansionDOS) {
          defaultValue.mansionId = defaultValue.customerRecordsMansionDOS.map(e => {
            return e.mansionId
          })
        }
        this.isSecrecy= defaultValue.isSecrecy
        this.type = defaultValue.type
        // defaultValue.projectEndtime = this.$moment(defaultValue.projectEndtime).format('YYYY-MM-DD');
        this.currProjectPossible = defaultValue.projectPossible
        this.$nextTick(() => {
          console.log('要设置的值:', defaultValue)
          setTimeout(() => {
            this.form.setFieldsValue(defaultValue)
          }, 500)
          this.initMansionOptionsWithMansionid(defaultValue.mansionId)
        })
      } else {
        this.peer = false
      }
    },
    initCustomerRecordTypes() {
      getDatadictChildsByPath('system.business_key.customer_record_type_set').then(res => {
        this.customerRecordTypes = res.data
        if (this.typeChangeVisible) { //追踪详情 客户详情中跟进填写的类型不包括看楼
          this.customerRecordTypes = this.customerRecordTypes.filter(e=>e.wordKey != '3')
        }else{
          this.customerRecordTypes = this.customerRecordTypes.filter(e=>e.wordKey != '7' && e.wordKey != '8')
        }
        this.customerRecordTypes.forEach(e => {
          e.wordKey = parseInt(e.wordKey)
        })
      })
      let customerRecordDO = this.form.getFieldsValue()
      console.log('跟进记录', customerRecordDO)
    },
    initMansionOptions(value) {
      if (value == null || value == '') {
        return
      }
      mansionApi.listAll({ queryText: value }).then(res => {
        if (res.code == 1) {
          this.mansionOptions = res.data
        }
      })
    },
    initMansionOptionsWithMansionid(id) {

      if (id && id.length > 0) {
        let p = new Promise((resolve, reject) => {
          // mansionApi.selectOne(id,2).then(res=>{
          mansionApi.selectByIds(id).then(res => {
            if (res.code == 1) {
              this.mansionOptions = res.data
              this.mansionList = res.data
              resolve()
            } else {
              reject()
            }
          })
        })
        return p
      }
    },
    submit() {
      this.loading = true
      console.log('isSecrecy', this.isSecrecy)
      this.form.validateFieldsAndScroll({ force: true }, (err, values) => {
        if (!err) {
          let customerRecordDO = this.form.getFieldsValue()
          if (customerRecordDO.mansionId) {
            customerRecordDO.customerRecordsMansionDOS = customerRecordDO.mansionId.map(m => {
              return {
                mansionId: m
              }
            })
          }
	        if(this.type == 3 && this.projectId){
		        customerRecordDO.customerRecordsMansionDOS = [{mansionId:this.mansionId}];
	        }
          if (this.defaultValue) {
            let defaultValue = JSON.parse(JSON.stringify(this.defaultValue))
            let pictureSyc = []
            if (this.pictureIds.length > 0) {
              this.pictureIds.forEach((item, index) => {
                pictureSyc.push(item)
              })
            }
            defaultValue.pictureSyc = pictureSyc
            defaultValue.peer = this.peer
            defaultValue.isSecrecy = this.isSecrecy

            if(defaultValue.newRelation != this.relationType){
              defaultValue.newRelation = this.relationType
              defaultValue.oldRelation = this.oldRelation
            }

            if(defaultValue.type != this.type){
              defaultValue.type = this.type
              defaultValue.oldType = this.oldType
            }
            if(defaultValue.newDemandStatus != this.demandStatus){
              defaultValue.newDemandStatus = this.demandStatus
              defaultValue.oldDemandStatus = this.oldDemandStatus
            }
            console.log("defaultValue",customerRecordDO.peerUsers)
            defaultValue.peerUsers = customerRecordDO.peerUsers
            if (defaultValue.peerUsers && defaultValue.peerUsers.length > 0) {
              defaultValue.peer = 0
            } else {
              defaultValue.peer = 1
            }
            // if (this.peer) {
            //   defaultValue.peerUsers = []
            // } else {
            //   defaultValue.peerUsers = customerRecordDO.peerUsers
            // }
            defaultValue.content = customerRecordDO.content
            defaultValue.customerRecordsMansionDOS = customerRecordDO.customerRecordsMansionDOS
            console.log("defaultValue",defaultValue)
            customerRecordsApi.update(defaultValue).then(res => {
              if (res.code == 1) {
                this.$message.success(res.message)
                this.$emit('saveSuccess')
                this.$refs.customerRelation.init();
                this.pictureIds = []
                this.tips = []
                this.checked = []
                //this.loading = false
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.loading = false
              this.canEdit=false
            })
          } else {

            let pictureSyc = []
            if (this.pictureIds.length > 0) {
              this.pictureIds.forEach((item, index) => {
                pictureSyc.push(item)
              })
            }
            console.log('pictureSyc', pictureSyc)
            customerRecordDO.pictureSyc = pictureSyc
            customerRecordDO.dealId = this.dealId
            customerRecordDO.projectId = this.projectId
            customerRecordDO.pursuitsId = this.pursuitsId
            customerRecordDO.customerId = this.customerId
            customerRecordDO.projectPossible = this.currProjectPossible
            customerRecordDO.peer = this.peer
            customerRecordDO.isSecrecy = this.isSecrecy
            customerRecordDO.newRelation = this.relationType
            customerRecordDO.oldRelation = this.oldRelation

            customerRecordDO.type = this.type
            customerRecordDO.oldType = this.oldType

            if(this.demandStatus != null ){
              customerRecordDO.newDemandStatus = this.demandStatus
            }else{
              customerRecordDO.newDemandStatus = customerRecordDO.demandStatus
            }
            if(this.oldDemandStatustr != null ){
              customerRecordDO.oldDemandStatus =this.oldDemandStatustr+""
            }else{
              customerRecordDO.oldDemandStatus = this.oldDemandStatus+""
            }
            console.log("customerRecordDO.peerUsers",customerRecordDO.peerUsers)
            if (customerRecordDO.peerUsers != undefined) {
              customerRecordDO.peer = 0
            } else {
              customerRecordDO.peer = 1
            }
						
            // if (this.peer) {
            //   customerRecordDO.peerUsers = []
            // }
            console.log('customerRecordDO', customerRecordDO)
            customerRecordsApi.insert(customerRecordDO).then(res => {
              if (res.code == 1) {
                this.$message.success(res.message)
                this.$emit('confirmDemand',customerRecordDO.newDemandStatus)
                this.$emit('saveSuccess')
                this.pictureIds =[];
                this.tips =[];
                this.checked =[];
                //this.loading = false;
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.loading = false

            })
          }
          this.isSecrecy = false
          this.peer = false
          this.form.resetFields()
        } else {
          this.loading = false
        }
      })
    }
  },
  watch: {
    visible(newVal,oldVal) {
      if (newVal) {
        this.type = null
        this.peer = false
        this.canEdit = false
        this.isSecrecy = false
        this.mansionList = []
        if (this.customerId){
          this.init()
          this.selectCustomerRecords()
        }
      }
    },
    // customerCompanyId(){
    //   this.init()
    //   this.selectCustomerRecords()
    //   console.log("对比1",this.customerCompanyId)
    //   console.log("对比1",this.userInfo.companyDO.companyId)
    //   if (this.customerCompanyId != this.userInfo.companyDO.companyId){
    //     this.isSecrecy = true;
    //   }
    // },
    customerId() {
      this.init()
      this.selectCustomerRecords()
    },
    DemandStatusType(){
      let demandStatustrs =  this.$t('track.demandStatustr')
      for(var i=0 ; i< demandStatustrs.length;i++){
        if(demandStatustrs[i].value == this.demandStatus) {
          this.decorators.demandStatus[1].initialValue = demandStatustrs[i].name
        }
      }
    }
  }
}
</script>

<style scoped lang='less'>
.customer_record {
  padding: 30px 20px;
  background: rgba(248, 249, 251, 0.62);
  border-radius: 0 0 4px 4px;
}
.btuSave{
  background: #3B2E26;
  border-radius: 2px;
  font-size: 12px;
  color: rgb(255, 255, 255);
  letter-spacing: 0px;
  font-weight: 600;
  width: 70px;
  height: 30px;
}
.cancle{
  border-radius: 2px;
  font-size: 12px;
  letter-spacing: 0px;
  font-weight: 600;
  width: 70px;
  height: 30px;
}
.isSecrecy {
  font-family: PingFangTC-Semibold;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 600;
}

.typeShow {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  width: 65px;
  height: 20px;
  border: 1px solid #CCCCCC;
  border-radius: 2px;
  cursor: pointer;

}

.ant-form-vertical .ant-form-item {
  padding: 0 10px;
}
</style>
